import { render, staticRenderFns } from "./ProductPricesForm.vue?vue&type=template&id=23ad8e9a&"
import script from "./ProductPricesForm.vue?vue&type=script&lang=js&"
export * from "./ProductPricesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports